import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Barcode from 'react-barcode';
import activoService from '../../../services/activoService';

const printStyles = `
  @page { size: 80mm 50mm; margin: 4mm; }
  @media print {
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { margin: 0; padding: 0; background: white; }
    .no-print { display: none !important; }
    .print-container { padding: 0; margin: 0; box-shadow: none; width: 100%; }
  }
  @media screen {
    body { background: #f3f4f6; }
    .print-container {
      width: 80mm; margin: 20px auto; background: white;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    }
    .print-actions { position: fixed; top: 20px; right: 20px; z-index: 1000; display: flex; gap: 10px; }
  }
  * { box-sizing: border-box; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #1f2937; background: white;
  }
  .print-container {
    background: white; padding: 6mm 4mm; width: 80mm;
    text-align: center;
  }
  .label-title {
    font-size: 9pt; font-weight: 700; margin: 0 0 4px 0;
    line-height: 1.2; word-break: break-word;
  }
  .label-subtitle {
    font-size: 7pt; color: #6b7280; margin: 0 0 6px 0;
    word-break: break-word;
  }
  .barcode-wrap { display: flex; justify-content: center; margin: 4px 0; }
  .label-code {
    font-family: 'Courier New', monospace; font-size: 8pt;
    font-weight: 600; margin-top: 2px;
  }
  .label-meta {
    font-size: 6.5pt; color: #4b5563; margin-top: 4px;
    line-height: 1.3;
  }
`;

const PrintActivoBarcode = () => {
  const { id } = useParams();
  const [activo, setActivo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await activoService.getActivo(id);
        if (response.success) setActivo(response.data);
      } catch (error) {
        console.error('Error al cargar activo:', error);
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4" />
          <p className="text-gray-600">Cargando etiqueta…</p>
        </div>
      </div>
    );
  }

  if (!activo) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-red-600 text-lg">Activo no encontrado</p>
      </div>
    );
  }

  return (
    <>
      <style>{printStyles}</style>

      <div className="print-actions no-print">
        <button
          type="button"
          onClick={() => window.print()}
          className="px-5 py-2.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 font-medium shadow-md"
        >
          Imprimir
        </button>
        <button
          type="button"
          onClick={() => window.close()}
          className="px-5 py-2.5 bg-gray-600 text-white rounded-lg hover:bg-gray-700 font-medium shadow-md"
        >
          Cerrar
        </button>
      </div>

      <div className="print-container">
        <p className="label-title">{activo.name}</p>
        {activo.serial_number ? (
          <p className="label-subtitle">Serie / placa: {activo.serial_number}</p>
        ) : null}
        <div className="barcode-wrap">
          <Barcode
            value={activo.code}
            format="CODE128"
            width={1.4}
            height={48}
            fontSize={11}
            margin={0}
            displayValue={false}
          />
        </div>
        <p className="label-code">{activo.code}</p>
        {(activo.brand || activo.model) && (
          <p className="label-meta">
            {[activo.brand, activo.model].filter(Boolean).join(' · ')}
          </p>
        )}
        {activo.area?.name ? (
          <p className="label-meta">{activo.area.name}</p>
        ) : null}
      </div>
    </>
  );
};

export default PrintActivoBarcode;
